import { memo } from "react";
import { Grid2 } from "@mui/material";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { useDebugBorder } from "@core/hooks/useDebugBorder";

interface TreeViewProps {
    height: number | string;
    children: React.ReactNode;
}

const TreeView = memo(({ height, children }: TreeViewProps) => {
    const border = useDebugBorder("green");

    return (
        <Grid2
            size={12}
            pb={2}
            height={height}
            overflow="auto"
            sx={{
                "&::-webkit-scrollbar": { display: "none" },
                scrollbarWidth: "none",
                "& .MuiTreeItem-group": {
                    marginLeft: 2,
                },
            }}
            border={border}
        >
            <SimpleTreeView
                defaultExpandedItems={["root"]}
                sx={{
                    width: "100%",
                    "& .MuiTreeItem-content": {
                        padding: 0,
                    },
                }}
            >
                {children}
            </SimpleTreeView>
        </Grid2>
    );
});

export default TreeView;
